module.exports = __webpack_public_path__ + "img/ics_o_package_failed_crrdon.7d918c72.svg";